import { render, staticRenderFns } from "./VueTipFileSelector.vue?vue&type=template&id=381e0214&scoped=true&"
import script from "./VueTipFileSelector.vue?vue&type=script&lang=js&"
export * from "./VueTipFileSelector.vue?vue&type=script&lang=js&"
import style0 from "./VueTipFileSelector.vue?vue&type=style&index=0&id=381e0214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381e0214",
  null
  
)

export default component.exports